import { render } from "./rankForm.vue?vue&type=template&id=2121479d"
import script from "./rankForm.vue?vue&type=script&lang=js"
export * from "./rankForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__